export type TurboScrollView = {
    scrollRoot: Pick<Window, "scrollTo">;
    scrollToPosition(position: { x: number; y: number }): void;
};

export function installInstantTurboScroll(view: TurboScrollView | undefined): void {
    if (!view) return;

    // Turbo 8.0.23 otherwise inherits Bootstrap's smooth scrolling for page positions.
    view.scrollToPosition = function ({ x, y }): void {
        this.scrollRoot.scrollTo({ left: x, top: y, behavior: "instant" });
    };
}
